export enum APIDocEnum {
  prod = 'https://api.cegrc.com',
  produk = 'https://api.cegrc.com',
}
